import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDataCatalogContext } from "../data-picker/DataCatalogContext";
import { pickerOutputLabel } from "../data-picker/outputLabel";
import { pickerTypeLabel } from "../data-picker/typeLabel";

// Read-only "Saídas" (C9): what this node produces for the nodes after it. They are not edited
// here; downstream nodes pick them through the DataPicker.
export const NodeOutputsSection = () => {
    const { t } = useTranslation();
    const own = useDataCatalogContext().self;
    if (!own || own.outputs.length === 0) return null;
    return (
        <Stack spacing={0.5} data-testid="node-outputs-section" sx={{ mt: 1.5 }}>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: 12 }}>
                {t("fluss.data.picker.outputs", { defaultValue: "Saídas" })}
            </Typography>
            {own.outputs.map((output) => (
                <Stack key={output.path} direction="row" spacing={1} alignItems="baseline" justifyContent="space-between">
                    <Typography variant="body2">
                        {pickerOutputLabel(t, { label: output.label, labelKey: output.label_key, key: output.key })}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ overflowWrap: "anywhere" }}>
                        {pickerTypeLabel(t, output.type)}
                    </Typography>
                </Stack>
            ))}
        </Stack>
    );
};

export default NodeOutputsSection;
